import { Button, ButtonColors } from '@chiroup/components/Button';
import { Icons } from '@chiroup/components/icons';
import React, { ChangeEvent } from 'react';
import { Link } from 'react-router-dom';

export type ModalActionButton = {
  text: string;
  onClick?: () => void | Promise<void>;
  color?: ButtonColors;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  icon?: Icons;
  visible?: boolean;
  href?: string;
  tooltip?: string;
  onSelectFile?: (e: ChangeEvent<HTMLInputElement>) => void;
};

type Props = {
  buttons: (ModalActionButton | React.ReactNode)[];
  className?: string;
};

const FooterButtons: React.FC<Props> = ({ buttons, className = '' }) => {
  return (
    <div className={`flex items-center gap-x-2 ${className}`}>
      {buttons?.map((button, index) => {
        if (React.isValidElement(button)) {
          return button;
        }

        const theButton = button as ModalActionButton;

        const tooltipIconClassName =
          theButton.color === ButtonColors.plain
            ? 'h-3 w-3 text-gray-500 inline-block ml-2 align-text-top'
            : 'h-3 w-3 text-white inline-block ml-2 align-text-top';

        // If href is provided, render as link
        if (theButton.href && !theButton.disabled) {
          const isExternal = theButton.href.startsWith('http');

          if (isExternal) {
            return (
              <a key={index} href={theButton.href} target="_blank" rel="noopener noreferrer">
                <Button
                  key={index}
                  text={theButton.text}
                  onClick={theButton.onClick}
                  color={theButton.color || ButtonColors.plainWithBorder}
                  disabled={theButton.disabled}
                  loading={theButton.loading}
                  className={theButton.className}
                  type={theButton.type}
                  icon={theButton.icon}
                  visible={theButton.visible}
                  tooltip={theButton.tooltip}
                  tooltipIconClassName={tooltipIconClassName}
                  onSelectFile={theButton.onSelectFile}
                  fileUpload={!!theButton.onSelectFile}
                />
              </a>
            );
          } else {
            return (
              <Link key={index} to={theButton.href}>
                <Button
                  key={index}
                  text={theButton.text}
                  onClick={theButton.onClick}
                  color={theButton.color || ButtonColors.plainWithBorder}
                  disabled={theButton.disabled}
                  loading={theButton.loading}
                  className={theButton.className}
                  type={theButton.type}
                  icon={theButton.icon}
                  visible={theButton.visible}
                  tooltip={theButton.tooltip}
                  tooltipIconClassName={tooltipIconClassName}
                  onSelectFile={theButton.onSelectFile}
                  fileUpload={!!theButton.onSelectFile}
                />
              </Link>
            );
          }
        }

        // Default button rendering
        return (
          <Button
            key={index}
            text={theButton.text}
            onClick={theButton.onClick}
            color={theButton.color || ButtonColors.plainWithBorder}
            disabled={theButton.disabled}
            loading={theButton.loading}
            className={theButton.className}
            type={theButton.type}
            icon={theButton.icon}
            visible={theButton.visible}
            tooltip={theButton.tooltip}
            tooltipIconClassName={tooltipIconClassName}
            onSelectFile={theButton.onSelectFile}
            fileUpload={!!theButton.onSelectFile}
          />
        );
      })}
    </div>
  );
};

export default FooterButtons;
